module.exports = __webpack_public_path__ + "static/media/CadillacGothic-Regular.woff";